export const SELECT_BUSINESS_ENTITY_NODES = {
  id: null,
  title: null,
} as const;

export const SELECT_BUSINESS_ENTITY_QUERY_NAME = 'SelectBusinessEntity';
